
import React from "react";
import { Link } from "react-router-dom";

export default class UserProfile extends React.Component 
{
    render()
     {
        return <div>
          <div className="container mt-5">

          <div className="text-center mt-3">
    <h1>My Profile</h1>
          </div>
    <div className="row d-flex justify-content-center">
        
        <div className="col-md-7">
            
            <div className="card p-3 py-4">
                
                <div className="text-center">
                    <img src="img/team-2.jpg"  width="100" className="rounded-circle"/>
                </div>
                
                <div className="text-center mt-3">
                    <span className="bg-secondary p-1 px-4 rounded text-white">Pro</span>
                    <br/><br/>
                    <h5 className="mt-2 mb-0">DILISHA VERMA</h5>
                    <span>Web Developer</span>
                    
                    {/* <div className="px-4 mt-1">
                        <p className="fonts">Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                    
                    </div> */}
                    <h5>About:- web developer </h5>
                    <h6>Address:- 32 VIJAY NAGAR INDORE </h6>
                    <h5>Contact:- 845548XXXX </h5>
                    <h5>Email:- Dilisha99@gmail.com </h5>
                    
                   <br/><br/>
                    
                 
                    
                    
                </div>
                
               
                
                
            </div>
            
        </div>
        
    </div>
    
</div>
        </div>

     }
}